import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'

export interface ICarOwnerInfo {
  car_id?: number
  car_name?: string
  desc?: string
}
export interface ICheYouListInfo {
  cheyou_list?: ICheYouListItem[]
  next_offset?: number
  count?: number
  total_count?: number
  has_more?: boolean
}
export interface ICheYouListItem {
  gid?: number
  gid_str?: string
  title?: string
  content?: string
  digg_count?: number
  comment_count?: number
  image_urls?: IImageUrl[]
  profile_info?: IProfileInfo
  ugc_question_info?: IUGCQuestionInfo
  article_type?: number
  article_sub_type?: number
  create_time?: number
  latest_comment_time?: number //最后回复时间
  display_time?: number
  comment_data?: ICommentData[]
  selected_level?: number
  video_detail_info?: IVideoInfo
  car_info?: IUgcCarInfo
  car_view_info?: IUgcCarViewInfo
  link_info?: IMotorLinkInfo
  bury_count?: number
  user_digg?: boolean
  user_bury?: boolean
  is_collect?: boolean
}
export interface ICommentData {
  aid?: number
  comment_id?: number
  comment_id_str?: string
  group_id?: number
  group_id_str?: string
  profile_info?: IProfileInfo
  comment_count?: number
  user_digg?: boolean
  digg_count?: number
  reply_count?: number
  is_author?: boolean
  text?: string
  reply_data?: IReplyData
  image_urls?: IImageUrl[]
  create_time?: number
  user_info?: {
    auth_info?: {
      auth_v_desc?: string
      auth_v_type?: number
    }
    avatar_url?: string
    follow?: boolean
    medal_list?: any
    name?: string
    user_description?: string | null
    user_id?: string
  }
  label_url?: string
}
export interface ICommunityInfo {
  open_url?: string
  motor_id?: number
  motor_name?: string
  motor_type?: number
}
export interface IImageUrl {
  img_type?: number
  url?: string
  width?: number
  height?: number
}
export interface IMedalInfo {
  id: number
  user_id: number
  type: number
  level: number
  desc_content: string
  status: number
  create_time: number
  modify_time: number
  expire_time: number
  upgrade_time: number
  show_start_time: number //点亮时间
  show_end_time: number
  icon_url: string
  extra: Record<string, string>
}
export interface IMotorAuthShowInfo {
  auth_v_type?: number //1,橙V; 2蓝V
  auth_v_desc?: string //描述信息
}
export interface IMotorIdentityInfo {
  identity?: string
  identity_desc?: string
  ans_num?: number
  digg_num?: number
  invited_num?: number
  car_identity_desc?: string
  answerer_identity_desc?: string
  cheyou_master_identity_desc?: string
  answerer_medal_url?: string
  answerer_medal_pop_url?: string
  medal_desc_url?: string
}
export interface IMotorLinkInfo {
  title?: string
  image_url?: string
  item_id?: number
  item_id_str?: string
  scheme?: string
  ui_style?: number
  name?: string
  community_info?: ICommunityInfo
  article_type?: number
}
export interface IProfileInfo {
  standard_user_info?: string
  schema?: string
  subscribed?: number
  fans_count?: number
  user_id?: number
  user_id_str?: string
  name?: string //用户名
  media_id?: number
  ugc_publish_media_id?: number
  avatar_url?: string
  user_verified?: number
  car_owner_info?: ICarOwnerInfo //汽车信息
  motor_identity_info?: IMotorIdentityInfo //圈子信息
  motor_auth_show_info?: IMotorAuthShowInfo //验证信息
  user_circle_grade?: IUserCircleGrade //用户圈子等级信息
  is_follow?: boolean //是否关注
  user_description_list?: IUserDescription[] //用户描述信息
  medal_list?: IMedalInfo[] //用户标签信息
  dynamic_count?: number //动态数量
  essence_count?: number //精华数量
  digg_count?: number //获赞数量
  comment_count?: number //评论数量
}
export interface IReplyData {
  aid?: number
  reply_id?: number
  reply_id_str?: string
  group_id?: number
  group_id_str?: string
  reply_to_reply_id?: number
  reply_to_reply_id_str?: string
  reply_to_comment_id?: number
  reply_to_comment_id_str?: string
  reply_to_reply_text?: string
  reply_to_user_info?: IReplyToUserInfo
  user_digg?: boolean
  digg_count?: number
  is_author?: boolean
  text?: string //回复文案
  image_urls?: IImageUrl[]
  create_time?: number
  profile_info?: IProfileInfo
}
export interface IReplyToUserInfo {
  avatar_url?: string
  name?: string
  user_id?: number
  user_id_str?: string
  user_description_list?: IUserDescription[] //用户描述信息
}
export interface IUGCQuestionInfo {
  status?: number
  status_display?: string
  participated?: string
  send_award?: string
  award_icon_url?: string
}
export interface IUgcCarInfo {
  car_id?: number
  car_name?: string
  series_id?: number
  series_name?: string
  year?: number
}
export interface IUgcCarViewInfo {
  score?: number
  score_level?: string
}
export interface IUserCircleGrade {
  amount?: number
  level?: number
  icon?: string
  color?: string
  rank_icon?: string
  rank_desc?: string
  rank_weeks?: number
}
export interface IUserDescription {
  icon: string
  description: string
  desc_type: number //1:认证用户 2:圈主 3:车主 4:运营标签 5:答主身份
  width: number
  height: number
}
export interface IVideoInfo {
  cover_url?: string //封面图信息
  video_id?: string //视频vid
  video_watch_count?: number //视频观看人数
  video_type?: number
  video_duration?: number //视频时长
  video_size?: string //视频大小list, 样例："{"1080p":{"duration":1219.263,"file_size":677901428,"h":1080,"w":1920},"4k":{"duration":1219.263,"file_size":2560095563,"h":2160,"w":3840},"high":{"duration":1219.267,"file_size":61686236,"h":480,"w":854},"normal":{"duration":1219.267,"file_size":63017752,"h":360,"w":640},"ultra":{"duration":1219.263,"file_size":201829423,"h":720,"w":1280}}"
}
interface ICheyouListParams {
  series_or_motor_id?: string
  sort_type?: number
  tab_name?: string
  offset?: number
  count?: number
}

const getCheyouList = async (params: ICheyouListParams, req?: any) => {
  const json = await fetch(
    getUrl(
      `/motor/pc/ugc/community/cheyou_list?${serializeObject(params)}`,
      'motor.pc_ugc.api'
    ),
    {
      req,
    }
  )

  if (0 !== json?.status) {
    throw Error(json?.prompts || json.message)
  }
  return json?.data
}
export default getCheyouList
